import React, {useState} from 'react'
import {Avatar, Stack, Typography} from '@mui/material'
import {useTranslation} from 'react-i18next'
import {useSelector} from 'react-redux'
import {RootState} from '../../../store'
import FixedNumber from '../../customTable/FixedNumber'
import {format, parseISO} from 'date-fns'
import {useNavigate} from 'react-router-dom'

export default function Row({item}: any) {
  const [editItem, setEditItem] = useState(item)
  const navagate = useNavigate()
  const store = useSelector((state: RootState) => state.vender)

  return (
    <>
      <tr className='fw-bold text-muted '>
        <td style={{cursor: 'pointer'}}>
          <a
            onClick={() => {
              navagate(`/orders/orders/${editItem.id}`)
            }}
            style={{color: '#009EF7'}}
          >
            #{editItem.order_number}
          </a>
        </td>
        <td style={{textAlign: store.isRtl === 0 ? 'start' : 'start'}}>
          <span className='text-muted  fs-7 fw-semibold'>{editItem.service_fees_amount}</span>
        </td>
        <td style={{textAlign: store.isRtl === 0 ? 'start' : 'start'}}>
          <span>
            {' '}
            <FixedNumber num={editItem.total} />
          </span>
        </td>
        <td style={{textAlign: store.isRtl === 0 ? 'start' : 'start'}}>
          <span className='text-muted  fs-7 fw-semibold'>
            {' '}
            {editItem.created_at && format(parseISO(editItem.created_at), 'yyyy-MM-dd')}
          </span>
        </td>
      </tr>
    </>
  )
}
